<div class="flex flex-col justify-center items-center p-2 w-full relative">
  <span
    class="w-6 h-6 text-center absolute top-1 right-1 cursor-pointer rounded-full box-bg hover:bg-primary"
    (click)="menu.toggle($event); $event.stopPropagation()">
    <i class="pi pi-ellipsis-v" style="font-size: 12px"></i>
  </span>
  <span
    tooltipPosition="top"
    tooltipStyleClass="custom-tooltip"
    showDelay="1500"
    class="w-6 h-6 text-center absolute bottom-1 right-1 cursor-pointer rounded-full box-bg hover:bg-primary"
    (click)="folderPopover.toggle($event); $event.stopPropagation()">
    <i class="pi pi-info" style="font-size: 12px"></i>
  </span>
  <div
    class="mx-auto text-center cursor-pointer w-fit"
    [draggable]="true"
    (dragstart)="onDragStart($event, data)"
    (click)="selectedFolderId(data)">
    <div><mat-icon class="big-icon" fontIcon="folder" /></div>
    <div>{{ data.name || data.id }}</div>
  </div>
  <p-menu
    #menu
    data-testid="folder_content_album__menu-popup"
    [appendTo]="'body'"
    [popup]="true"
    [model]="items">
    <ng-template #start />
    <ng-template #submenuheader let-item>
      @if (item?.visible !== false) {
        <div class="text-blue-500 font-bold" data-testid="folder_content_album__submenu-header">
          {{ item.label }}
        </div>
      }
    </ng-template>
    <ng-template #item let-item>
      @if (item?.visible !== false) {
        <a
          class="flex items-center p-2 cursor-pointer gap-2"
          data-testid="folder_content_album__menu-item">
          <span
            class="inline-flex items-center justify-center {{
              item?.icon_color ? item?.icon_color : 'text-blue-500'
            }}">
            <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
          </span>
          <span class="inline-flex flex-col gap-2">
            <span class="font-light text-sm">{{ item.label }}</span>
          </span>
        </a>
      }
    </ng-template>
  </p-menu>
</div>
<p-dialog
  header="{{ 'Select a folder' | translate }}"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="selectFolder"
  (onHide)="onlyCloseDialog()">
  @if (selectFolder) {
    <offconon-folder-tree
      [folderList]="folderList"
      [selected_album_id]="data.id"
      [selected_file_album_id]="selectedAlbumId.id"
      [copyAction]="copyAction"
      (MovedFilesEmit)="closeDialog()" />
  }
</p-dialog>
<p-popover #folderPopover>
  <div class="flex flex-col">
    <div class="font-bold mb-3">{{ 'Folder details' | translate }}:</div>
    <div class="text-gray text-sm">
      <div>{{ 'Folder name' | translate }}: {{ data.name }}</div>
      <div
        *ngIf="data.description && data.description !== ''"
        class="max-w-xs break-words whitespace-normal">
        {{ 'Description' | translate }}: {{ data.description }}
      </div>
      <div class="max-w-xs break-words whitespace-normal">
        {{ 'Items' | translate }}: {{ data.items_count }}
      </div>
      <div *ngIf="data.total_file_size && data.total_file_size > 0">
        {{ 'Total size' | translate }}:
        {{ (data.total_file_size || 0) / 1000000 || 0 | number: '1.2-2' }} Mb
      </div>
    </div>
  </div>
</p-popover>
<p-confirmDialog
  [key]="'deletefolder-' + data.id"
  [breakpoints]="{ '960px': '75vw' }"
  [baseZIndex]="12"
  [appendTo]="'body'">
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
      <span class="font-bold text-2xl block mb-2 mt-6">{{ message?.header }}</span>
      <p class="mb-0">{{ message?.message }}</p>
      <div class="flex items-center gap-2 mt-6">
        <p-button label="{{ 'Yes, I want to delete it.' | translate }}" (onClick)="onAccept()" />
        <p-button label="{{ 'Cancel' | translate }}" [outlined]="true" (onClick)="onReject()" />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
<p-dialog
  header="{{ 'Edit folder' | translate }}"
  [appendTo]="'body'"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="editFolder"
  (onHide)="onlyCloseEditDialog()">
  <div class="p-2">
    <div class="pt-3">
      @if (editFolder) {
        <offconon-media-folder-form-common
          [user_id]="user_id"
          [edit_id]="data.id"
          [album_id]="data.id"
          [name]="data.name"
          [business_id]="business_id"
          (formSavedDataEvent)="savedForm($event)" />
      }
    </div>
  </div>
</p-dialog>
